export default "__VITE_ASSET__36P77vQ4__"